<template>
    <AppLayout
        page="/dashboard"
        pageTitle="Exit Forms"
        backLink="/dashboard/reports"
    >
        <v-overlay :value="retryLoading" z-index="999">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-col cols="12" class="pa-1">
            <v-card class="soli-round">
                <v-container class="px-3" fluid>
                    <v-list>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="soli-subtitle"
                                    >{{
                                        `${globalMomentMonthFull(
                                            rangeStart
                                        )} ${globalMomentYear(rangeStart)}`
                                    }}
                                </v-list-item-title>
                                <v-list-item-subtitle
                                    style="white-space: normal"
                                    >{{
                                        allLocations
                                            ? "Exit Forms By Location"
                                            : selectedLocation.name
                                    }}
                                </v-list-item-subtitle>
                                <v-list-item-subtitle
                                    class="font-bold py-1"
                                    style="white-space: normal"
                                    ><v-btn
                                        v-if="can('View admin reports')"
                                        x-small
                                        outlined
                                        class="soli-round soli-blue-text"
                                        @click="range(0, !allLocations)"
                                        >{{
                                            allLocations
                                                ? `View ${selectedLocation.name}`
                                                : `View All Locations`
                                        }}</v-btn
                                    >
                                    <v-btn
                                        v-if="!allLocations"
                                        x-small
                                        outlined
                                        class="soli-round soli-blue-text"
                                        @click="
                                            expanded.length
                                                ? (expanded = [])
                                                : (expanded = exits)
                                        "
                                        >{{
                                            expanded
                                                ? "Detail View"
                                                : "List View"
                                        }}</v-btn
                                    >
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-row>
                                    <v-menu
                                        left
                                        offset-y
                                        max-width="250"
                                        :close-on-content-click="false"
                                    >
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                :small="$vuetify.breakpoint.xs"
                                                icon
                                                class="elevation-3 mr-4"
                                            >
                                                <v-badge
                                                    color="accent"
                                                    overlap
                                                    bordered
                                                    dot
                                                    :value="search"
                                                >
                                                    <v-icon
                                                        class="soli-blue-text text-shadow-blue"
                                                        >tune</v-icon
                                                    >
                                                </v-badge></v-btn
                                            >
                                        </template>
                                        <v-list
                                            ><v-list-item>
                                                <v-text-field
                                                    v-model="search"
                                                    label="Filter"
                                                    single-line
                                                    outlined
                                                    dense
                                                    clearable
                                                    :append-icon="
                                                        search ? null : 'tune'
                                                    "
                                                    hide-details
                                                ></v-text-field></v-list-item
                                            ><v-list-item v-if="allLocations"
                                                ><v-select
                                                    label="Group By"
                                                    dense
                                                    outlined
                                                    item-text="display"
                                                    item-value="value"
                                                    @input="setGroupBy($event)"
                                                    v-model="groupBy"
                                                    :items="[
                                                        {
                                                            display:
                                                                'Total Exits',
                                                            value: null,
                                                        },
                                                        {
                                                            display: 'Location',
                                                            value: 'location',
                                                        },
                                                        {
                                                            display: 'Date',
                                                            value: 'date',
                                                        },
                                                    ]"
                                                    return-object
                                                    hide-details
                                                ></v-select></v-list-item></v-list
                                    ></v-menu>
                                </v-row>
                            </v-list-item-action>
                            <v-list-item-action
                                ><v-row>
                                    <v-btn
                                        :small="$vuetify.breakpoint.xs"
                                        icon
                                        class="elevation-3"
                                        @click="range(-1, allLocations)"
                                        ><v-icon color="dark"
                                            >chevron_left</v-icon
                                        ></v-btn
                                    >
                                    <v-btn
                                        :small="$vuetify.breakpoint.xs"
                                        icon
                                        class="elevation-3 ml-1"
                                        @click="range(1, allLocations)"
                                        ><v-icon color="dark"
                                            >chevron_right</v-icon
                                        ></v-btn
                                    >
                                    <v-text-field
                                        v-if="false"
                                        v-model="search"
                                        style="width: 200px"
                                        class="pl-6"
                                        append-icon="filter_list"
                                        label="Filter"
                                        single-line
                                        hide-details
                                    ></v-text-field
                                ></v-row>
                            </v-list-item-action> </v-list-item
                    ></v-list>
                    <v-data-table
                        v-if="allLocations && !byLocation"
                        :headers="headers"
                        :items="exits"
                        hide-default-footer
                        disable-pagination
                        mobile-breakpoint="0"
                        :search="search"
                    >
                        <template v-slot:[`location`]="{ item }">
                            <div class="d-flex align-center py-2">
                                <div>
                                    <v-list-item-title>
                                        {{ item.location }}
                                    </v-list-item-title>
                                </div>
                            </div>
                        </template>
                        <template v-slot:[`total`]="{ item }">
                            <div class="d-flex align-center py-2">
                                <div>
                                    <v-list-item-title>
                                        {{ item.total }}
                                    </v-list-item-title>
                                </div>
                            </div>
                        </template>
                    </v-data-table>
                    <v-data-table
                        v-if="!allLocations || byLocation"
                        :headers="headers"
                        :items="exits"
                        hide-default-footer
                        disable-pagination
                        mobile-breakpoint="0"
                        :search="search"
                        :group-by="groupBy.value"
                        show-expand
                        :expanded.sync="expanded"
                        @click:row="null /*showExitForm = $event*/"
                    >
                        <template v-slot:[`item.info`]="{ item }">
                            <div class="d-flex align-center py-2">
                                <div>
                                    <Link
                                        v-if="item.info.user_id"
                                        :href="`/profile/${item.info.user_id}/account`"
                                    >
                                        <v-list-item-title>
                                            {{ item.info.name }}
                                        </v-list-item-title>
                                    </Link>
                                    <v-list-item-title v-else>
                                        {{ item.info.name }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        {{ item.info.email }}
                                    </v-list-item-subtitle>
                                </div>
                            </div>
                        </template>
                        <template v-slot:[`item.student`]="{ item }">
                            <div class="d-flex align-center py-2">
                                <div>
                                    <v-list-item-title>
                                        {{ item.student.name }}
                                    </v-list-item-title>
                                </div>
                            </div>
                        </template>
                        <template v-slot:[`item.status`]="{ item }">
                            <!--
                                                        <v-select
                                v-model="item.status"
                                :items="[
                                    {
                                        icon: 'radio_button_unchecked',
                                        text: 'Pending',
                                        color: 'soli-status-red',
                                    },
                                    {
                                        icon: 'check_circle',
                                        text: 'Processed',
                                        color: 'soli-status-green',
                                    },
                                    {
                                        icon: 'celebration',
                                        text: 'Reversed',
                                        color: 'soli-status-blue',
                                    },
                                ]"
                                prependInnerIcon="celebration"
                                color="soli-status-blue"
                                returnObject
                                outlined
                                dense
                                hideDetails
                            >
                            </v-select>
                            -->
                            <!--<v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-chip
                                        v-bind="attrs"
                                        v-on="on"
                                        small
                                        :color="
                                            item.status == 'Pending'
                                                ? 'soli-status-red'
                                                : item.status == 'Processed'
                                                ? 'soli-status-green'
                                                : 'soli-status-blue'
                                        "
                                        class="white--text font-bold"
                                        >{{ item.status }}
                                        <v-icon right
                                            >keyboard_arrow_down</v-icon
                                        ></v-chip
                                    ></template
                                >
                                <v-list>
                                    <v-list-item
                                        v-for="(option, index) in [
                                            'Pending',
                                            'Processed',
                                            'Reversed',
                                        ]"
                                        :key="index"
                                    >
                                        <v-list-item-title>{{
                                            option
                                        }}</v-list-item-title
                                        ><v-icon
                                            v-if="option == item.status"
                                            right
                                            color="primary"
                                            >check_circle</v-icon
                                        >
                                    </v-list-item>
                                </v-list></v-menu
                            >-->
                            <v-chip
                                small
                                :color="
                                    item.status == 'Pending'
                                        ? 'soli-status-red'
                                        : item.status == 'Processed'
                                        ? 'soli-status-green'
                                        : 'soli-status-blue'
                                "
                                class="white--text font-bold"
                                >{{ item.status }}
                            </v-chip>
                        </template>
                        <!--<template v-slot:[`item.processed`]="{ item }">
                            <div class="d-flex align-center py-2">
                                <v-icon v-if="!item.processed"
                                    >radio_button_unchecked</v-icon
                                >
                                <v-icon v-else color="green"
                                    >check_circle</v-icon
                                >
                            </div>
                        </template>-->
                        <template v-slot:[`item.date`]="{ item }">
                            <div class="d-flex align-center py-2">
                                <div>
                                    <v-list-item-title>
                                        {{
                                            globalMomentDate(
                                                new Date(item.date)
                                            )
                                        }}
                                    </v-list-item-title>
                                </div>
                            </div>
                        </template>

                        <template v-slot:expanded-item="{ headers, item }">
                            <td :colspan="headers.length" class="ma-3">
                                <div class="ma-3">
                                    <v-simple-table>
                                        <thead>
                                            <tr>
                                                <th class="text-left">
                                                    Final lesson
                                                </th>
                                                <th class="text-left">
                                                    Why exit?
                                                </th>
                                                <th class="text-left">Other</th>
                                                <th class="text-left">
                                                    Perfect match?
                                                </th>
                                                <th class="text-left">Why?</th>
                                                <th class="text-left">
                                                    Confidential?
                                                </th>
                                                <th
                                                    class="text-left"
                                                    v-if="item.form.recommend"
                                                >
                                                    Recommend us?
                                                </th>
                                                <th class="text-left">NPS</th>
                                                <th class="text-left">
                                                    NPS reason?
                                                </th>
                                                <th class="text-left">
                                                    Re-enroll?
                                                </th>
                                                <th class="text-left">When?</th>
                                                <th class="text-left">
                                                    Do better?
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    {{
                                                        globalMomentDate(
                                                            new Date(
                                                                item.form.final_lesson_date
                                                            )
                                                        )
                                                    }}
                                                </td>
                                                <td>
                                                    <div class="flex-col">
                                                        <div
                                                            v-for="reason in item
                                                                .form.why_exit"
                                                            :key="reason"
                                                        >
                                                            <small>
                                                                · {{ reason }}
                                                            </small>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    {{
                                                        item.form
                                                            .why_exit_reason
                                                    }}
                                                </td>
                                                <td>
                                                    {{
                                                        item.form.perfect_match
                                                            ? "Yes"
                                                            : "No"
                                                    }}
                                                </td>
                                                <td>
                                                    {{
                                                        item.form
                                                            .perfect_match_reason
                                                    }}
                                                </td>
                                                <td>
                                                    {{
                                                        item.form.confidential
                                                            ? "Yes"
                                                            : "No"
                                                    }}
                                                </td>
                                                <td v-if="item.form.recommend">
                                                    {{
                                                        item.form.recommend
                                                            ? "Yes"
                                                            : "No"
                                                    }}
                                                </td>
                                                <td>
                                                    {{ item.form.nps_value }}
                                                </td>
                                                <td>
                                                    {{ item.form.nps_reason }}
                                                </td>
                                                <td>
                                                    {{
                                                        item.form.will_return
                                                            ? "Yes"
                                                            : "No"
                                                    }}
                                                </td>
                                                <td>
                                                    {{
                                                        item.form.return_date
                                                            ? globalMomentDate(
                                                                  new Date(
                                                                      item.form.return_date
                                                                  )
                                                              )
                                                            : null
                                                    }}
                                                </td>
                                                <td>
                                                    {{ item.form.do_better }}
                                                </td>
                                            </tr>
                                        </tbody></v-simple-table
                                    >
                                </div>
                            </td>
                        </template>
                    </v-data-table>
                </v-container>
            </v-card>
        </v-col>

        <!--<SoliResponsiveDialog
            v-if="showExitForm"
            @reset="showExitForm = false"
            title="Exit Form"
            ><template #body
                ><v-list>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-subtitle
                                >Select the date of your final
                                lesson</v-list-item-subtitle
                            >
                            <v-list-item-title>{{
                                showExitForm.info.name
                            }}</v-list-item-title>
                        </v-list-item-content></v-list-item
                    >
                </v-list></template
            ></SoliResponsiveDialog
        >-->
    </AppLayout>
</template>

<script>
import AppLayout from "./../../Layouts/AppLayout";
import { Link } from "@inertiajs/vue2";
import globalMoment from "../../Mixins/GlobalMoment";

export default {
    name: "ExitForms",
    props: {
        exits: {
            type: Array,
            default: () => [],
        },
        selectedLocation: {
            type: Object,
            default: null,
        },
        allLocations: {
            type: Boolean,
            default: false,
        },
        byLocation: {
            type: Boolean,
            default: false,
        },
        rangeStart: {
            type: String,
            default: null,
        },
    },
    mixins: [globalMoment],
    components: {
        AppLayout,
        Link,
    },
    data() {
        return {
            search: "",
            retryLoading: false,
            showMessage: false,
            groupBy: { display: "Total Exits", value: null },
            //showExitForm: null,
            expanded: [],
        };
    },
    computed: {
        headers() {
            if (this.allLocations && !this.byLocation) {
                return [
                    {
                        text: "Location",
                        align: "start",
                        sortable: true,
                        value: "location",
                    },
                    {
                        text: "Exits",
                        align: "start",
                        sortable: true,
                        value: "total",
                    },
                    {},
                ];
            }
            return [
                {
                    text: "Account",
                    align: "start",
                    sortable: true,
                    value: "info",
                },
                {
                    text: "Student",
                    align: "start",
                    sortable: true,
                    value: "student",
                },
                {
                    text: "NPS",
                    align: "start",
                    sortable: true,
                    value: "form.nps_value",
                },
                {
                    text: "Status",
                    align: "start",
                    sortable: true,
                    value: "status",
                    width: "150px",
                },
                /*{
                    text: "Processed",
                    align: "start",
                    sortable: true,
                    value: "processed",
                },*/
                {
                    text: "Submitted",
                    align: "start",
                    sortable: true,
                    value: "date",
                },
            ];
        },
    },
    methods: {
        setGroupBy(select) {
            if (!select.value) return this.range(0, true, false);
            if (this.byLocation) return null;
            this.range(0, true, true);
        },
        range(adjust, allLocations = false, byLocation = false) {
            this.$inertia.visit(
                `/dashboard/reports/exit-forms/${moment(
                    new Date(this.rangeStart)
                )
                    .tz("UTC")
                    .add(adjust, "M")
                    .startOf("month")
                    .format("YYYY-MM-DD")}`,
                {
                    data: {
                        allLocations: Number(allLocations),
                        byLocation: Number(byLocation),
                    },
                    preserveState: true,
                }
            );
        },
    },
};
</script>
